module.exports = __webpack_public_path__ + "ota-icons.774b371534c4d39c5397.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ota-icons/fonts/ota-icons.svg?xst5zg
// module id = 968
// module chunks = 24